export type JobChange = {
  canPerformJobChange?: boolean;
  serviceOrderId?: string;
  serviceCaseId?: string;
} & (
  | {canPerformJobChange: true; serviceOrderId: string; serviceCaseId: string}
  | {canPerformJobChange?: false; serviceOrderId?: never; serviceCaseId?: never}
);
